let cb = () => {};

export const setValueToDisplay = (value) => cb(value);

export const onChangeDisplaydValue  = (setValueToDisplay) => cb = setValueToDisplay;
